import React from 'react';

const RecoveryMismatchSummaryPanel = ({ rows = [] }) => {
  const items = Array.isArray(rows) ? rows : [];

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <h3 className="mb-3 text-sm font-semibold text-slate-100">Mismatch Summary</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs text-slate-200">
          <thead className="bg-slate-950/80 text-[11px] uppercase tracking-wide text-slate-400">
            <tr>
              <th className="px-3 py-2 text-left">Category</th>
              <th className="px-3 py-2 text-right">Count</th>
            </tr>
          </thead>
          <tbody>
            {items.length ? items.map((row) => (
              <tr key={row.category} className="border-t border-slate-800">
                <td className="px-3 py-2">{row.category}</td>
                <td className="px-3 py-2 text-right">{row.count}</td>
              </tr>
            )) : (
              <tr>
                <td className="px-3 py-3 text-slate-400" colSpan={2}>Tidak ada mismatch summary.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default RecoveryMismatchSummaryPanel;
